import script from "./NewsPageRubricsList.vue?vue&type=script&setup=true&lang=js"
export * from "./NewsPageRubricsList.vue?vue&type=script&setup=true&lang=js"

import "./NewsPageRubricsList.vue?vue&type=style&index=0&id=5fc6e7e8&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5fc6e7e8"]])

export default __exports__